import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { useReader } from "@/components/Layout";
import { coverThumbUrl } from "@/lib/appresse";

export const NewIssueBanner = ({ items, onClose }) => {
  const { openReader } = useReader();
  useEffect(() => {
    if (!items.length) return undefined;
    const t = setTimeout(onClose, 8000);
    return () => clearTimeout(t);
  }, [items, onClose]);
  const first = items[0];
  return (
    <AnimatePresence>
      {first ? (
        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.96 }}
          className="fixed top-3 left-1/2 -translate-x-1/2 z-50 w-[min(92vw,420px)]" data-testid="new-issue-banner">
          <div className="flex items-center gap-3 rounded-2xl bg-primary text-primary-foreground shadow-2xl p-2 pr-3">
            <button onClick={() => { openReader(first); onClose(); }} className="flex items-center gap-3 flex-1 min-w-0 text-left" data-testid="new-issue-open">
              <img src={coverThumbUrl(first.id)} alt="" className="w-10 h-14 object-cover rounded-md bg-white shrink-0" />
              <span className="min-w-0">
                <span className="flex items-center gap-1 text-xs font-bold uppercase tracking-wide"><Sparkles className="w-3.5 h-3.5" /> Nouvelle revue en ligne{items.length > 1 ? ` (+${items.length - 1})` : ""}</span>
                <span className="block text-sm truncate">{first.title}</span>
              </span>
            </button>
            <button onClick={onClose} aria-label="Fermer" className="p-1 rounded-full hover:bg-white/20" data-testid="new-issue-close"><X className="w-4 h-4" /></button>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
